<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">

    <!-- Header -->
    <header class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ "products" | transloco }}</span>
        <h2 class="bb-page-title">{{ "products" | transloco }}</h2>
        <p class="bb-page-subtitle">{{ "item name" | transloco }}</p>
      </div>

 
    </header>

    <!-- Floating Cart -->
    <div *ngIf="cartItemCount > 0" class="bb-floating-cart floating-cart" (click)="cartPopUpOpen()">
      <span class="bb-floating-cart-count count">{{ cartItemCount }}</span>
      <i class="fa-solid fa-cart-shopping"></i>
      {{ "Cart" | transloco }}
    </div>

    <!-- Search -->
    <div class="bb-filter-card">
      <div class="search-row">
        <div class="search-box bb-search-full">
          <input
            type="text"
            class="bb-input"
            [(ngModel)]="searchKey"
            (keyup.enter)="search()"
            placeholder="{{ 'item name' | transloco }}"
          />

          <button *ngIf="!searched" class="bb-btn bb-btn-primary" (click)="search()">
            {{ "Search" | transloco }}
          </button>

          <button *ngIf="searched" class="bb-btn bb-btn-secondary" (click)="clearSearch()">
            {{ "clear search" | transloco }}
          </button>
        </div>
      </div>
    </div>

    <!-- Categories -->
    <div class="bb-card bb-p-16 bb-mt-16">
      <div class="bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap bb-mb-12">
        <h4 class="bb-m-0 bb-text-navy bb-font-bold">
          {{ "Category" | transloco }}
        </h4>
      </div>

      <div class="bb-category-scroll">
        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 0" (click)="getByCategory(0)">
          {{ "soft food" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 1" (click)="getByCategory(1)">
          {{ "soft food can" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 2" (click)="getByCategory(2)">
          {{ "dry food" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 3" (click)="getByCategory(3)">
          {{ "bird food" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 4" (click)="getByCategory(4)">
          {{ "medicine" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 5" (click)="getByCategory(5)">
          {{ "supplement" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 6" (click)="getByCategory(6)">
          {{ "accessories" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 7" (click)="getByCategory(7)">
          {{ "toy" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 8" (click)="getByCategory(8)">
          {{ "grooming" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 9" (click)="getByCategory(9)">
          {{ "house" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 10" (click)="getByCategory(10)">
          {{ "care" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 11" (click)="getByCategory(11)">
          {{ "treats" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 12" (click)="getByCategory(12)">
          {{ "training pads" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 13" (click)="getByCategory(13)">
          {{ "bags" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 14" (click)="getByCategory(14)">
          {{ "cleaning tools" | transloco }}
        </button>

        <button type="button" class="bb-category-pill" [class.active]="catagoryId === 15" (click)="getByCategory(15)">
          {{ "litter" | transloco }}
        </button>
      </div>
    </div>

    <!-- No Data -->
    <div *ngIf="noData" class="bb-empty-state bb-text-center">
      <app-nodata></app-nodata>
    </div>

    <!-- Products -->
    <div class="bb-products-grid" *ngIf="!noData">
      <div
        class="bb-product-card"
        *ngFor="let item of allData; trackBy: trackById"
        [class.out]="toInt(item.quantity) === 0"
        [class.low]="toInt(item.quantity) <= 10 && canSeeAllPrices()"
      >

        <!-- Image -->
        <div class="bb-product-card-img">
          <img [src]="item.image ? fixImage(item.image) : '/assets/noproduct.png'" [alt]="'product' | transloco" />

          <span *ngIf="toInt(item.quantity) === 0" class="bb-badge bb-badge-danger">
            {{ 'out of stock' | transloco }}
          </span>
        </div>

        <!-- Name -->
        <h6 class="bb-product-card-title">
          {{ isAr ? item.name_ar : item.name_en }}
        </h6>

        <!-- Prices -->
        <ng-container *ngIf="canSeeAllPrices(); else singlePriceBlock">
          <div class="bb-product-price-row">
            <span>{{ item.price }} {{ "egpe" | transloco }}</span>
            <span>{{ item.affiliationprice }} {{ "egpe" | transloco }}</span>
          </div>

          <div class="bb-product-price-row">
            <span>{{ item.pricea }} {{ "egpe" | transloco }}</span>
            <span>{{ item.priceb }} {{ "egpe" | transloco }}</span>
            <span>{{ item.pricec }} {{ "egpe" | transloco }}</span>
          </div>
        </ng-container>

        <ng-template #singlePriceBlock>
          <div class="bb-product-price-row" *ngIf="accountTypeService.isAffiliation()">
            <span>{{ item.affiliationprice }} {{ "egpe" | transloco }}</span>
          </div>

          <div class="bb-product-price-row" *ngIf="accountTypeService.isA()">
            <span>{{ item.price }} {{ "egpe" | transloco }}</span>
          </div>

          <div class="bb-product-price-row" *ngIf="accountTypeService.isB()">
            <span>{{ item.priceb }} {{ "egpe" | transloco }}</span>
          </div>

          <div class="bb-product-price-row" *ngIf="accountTypeService.isC()">
            <span>{{ item.pricec }} {{ "egpe" | transloco }}</span>
          </div>
        </ng-template>

        <!-- Quantity -->
        <p class="bb-product-quantity">
          {{ "quantity" | transloco }}:
          <strong>{{ item.quantity }}</strong>
        </p>

        <!-- Add To Cart -->
        <button
          type="button"
          class="bb-btn bb-btn-primary bb-w-100 bb-mt-12"
          [class.bb-btn-secondary]="isInCart(item)"
          (click)="addToCart(item)"
        >
          {{ isInCart(item) ? ('added' | transloco) : ('addtocart' | transloco) }}
        </button>

      </div>
    </div>

  </div>
</section>

<!-- Cart Popup -->
<div *ngIf="cartPopUp" class="bb-modal-backdrop popup">
  <div class="bb-modal-card bb-modal-sm popup-content">

    <div class="bb-modal-header">
      <h4>{{ "Cart" | transloco }}</h4>

      <button class="bb-modal-close" (click)="close()" type="button">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="bb-cart-list cart-cont">
      <div *ngFor="let item of cartItems" class="bb-cart-item cart-item">
        <span>{{ isAr ? item.name_ar : item.name_en }}</span>

        <button type="button" class="bb-icon-btn bb-icon-btn-danger" (click)="removeFromCart(item)">
          <i class="fa-solid fa-trash"></i>
        </button>
      </div>
    </div>

    <div class="bb-modal-actions">
      <button class="bb-btn bb-btn-primary" (click)="quickOrder()">
        {{ 'proceed to add order' | transloco }}
      </button>

      <button class="bb-btn bb-btn-secondary" routerLink="/myclients.mobile">
        {{ "myclients" | transloco }}
      </button>
    </div>

  </div>
</div>